import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

// App Constants
import appRoutes from '../../constants/appRoutes';

// App components
import Navigation from '../Navigation';

/**
 * This container is linked to the store `upload` key and the routing data. it wraps the Navigation component.
 * @extends {Component}
 */
class NavigationContainer extends React.Component {
  constructor(props) {
    super(props);

    this.isNavigationEnabled = this.isNavigationEnabled.bind(this);
  }

  /**
   * It returns if the cropped image url is defined or not.
   * @return {Boolean}
   */
  isResultURLValid() {
    return !!this.props.croppedImageUrl;
  }

  /**
   * It returns if the image url is defined or not.
   * @return {Boolean}
   */
  isCropURLValid() {
    return !!this.props.imageUrl;
  }

  /**
   * This method defines whether the navigation to the other page is enabled or not. It will check
   * against the redux store if the the given route is valid and if that is the case it will call the
   * URL specific method validator, otherwise it will return true.
   * @param {String} route The route name.
   * @return {Boolean}
   */
  isNavigationEnabled(route) {
    switch (route) {
      case appRoutes.crop:
        return this.isCropURLValid();
      case appRoutes.result:
        return this.isResultURLValid();
      default:
        return true;
    }
  }

  /**
   * This method defines whether the item should contain the `active` class or not.
   * @param {String} newRoute The route path.
   */
  navigateRoute(newRoute) {
    if (this.isNavigationEnabled(newRoute)) {
      this.props.navigate(newRoute);
    }
  }

  render() {
    return (
      <Navigation activeItem={this.props.currentRoute} itemClicked={newRoute => this.navigateRoute(newRoute)} />
    );
  }
}

/**
 * Set the NavigationContainer component props default values.
 * @type {Object}
 */
NavigationContainer.defaultProps = {
  currentRoute: appRoutes.upload,
  imageUrl: '',
  croppedImageUrl: '',
  navigate: () => { },
};

/**
 * Declare the NavigationContainer component PropTypes
 * @type {Object}
 * @property {String} currentRoute    It defines what is the current route path.
 * @property {String} imageUrl        Image url for the crop area.
 * @property {String} croppedImageUrl Cropped Image url.
 * @property {Func}   navigate        This callback will redirect to the needed path.
 */
NavigationContainer.propTypes = {
  currentRoute: PropTypes.string,
  imageUrl: PropTypes.string,
  croppedImageUrl: PropTypes.string,
  navigate: PropTypes.func,
};

/**
 * It dispatches store action and returns an object of actions that will be merged with component props.
 * @param   {Object} dispatch bind action creators.
 * @returns {Object}
 */
const mapDispatchToProps = dispatch => ({
  navigate: newRoute => dispatch(push(newRoute)),
});

export default connect(
  state => ({
    currentRoute: state.router.location ? state.router.location.pathname : appRoutes.upload,
    imageUrl: state.upload.imageUrl,
    croppedImageUrl: state.crop.croppedImageUrl,
  }),
  mapDispatchToProps
)(NavigationContainer);




// WEBPACK FOOTER //
// ./src/components/NavigationContainer/index.js